/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_appsync_graphqlEndpoint": "https://vliurrhr3jdnlmv6ret66cdijm.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4trj5tn46ffpvli7smvtzxbdlu",
    "aws_cognito_identity_pool_id": "ca-central-1:8a2517c6-5810-447c-b582-4ea233d0d91d",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_qkb7YKvqe",
    "aws_user_pools_web_client_id": "6upjc2cu4q8ni9qbcit60jmjjl",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "eventhives3bucket200214-prod",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
